module.exports = __webpack_public_path__ + "img/fi1.1283a53d.png";